export default {"src":"/_next/static/media/khaje-nasir.bc1e7999.svg","height":37,"width":31,"blurWidth":0,"blurHeight":0};